<template>
  <div>
    <SeedJung_Header></SeedJung_Header>
    <div class="mypage-container">
      <h2 class="sc-fzsDOv">마이페이지</h2>
      <div class="profile-section">
        <!-- 기본 정보 표시 -->
        <div class="info-group">
          <label>아이디</label>
          <div class="info-value">{{ username }}</div>
        </div>

        <form @submit.prevent="handleUpdate" class="profile-form">
          <div class="info-group">
            <label>닉네임</label>
            <input 
              type="text" 
              v-model="userInfo.nickname"
              :disabled="!isEditing"
              class="form-input"
            >
          </div>

          <div class="info-group">
            <label>이메일</label>
            <input 
              type="email" 
              v-model="userInfo.email"
              :disabled="!isEditing"
              class="form-input"
            >
          </div>

          <!-- 수정 모드일 때만 비밀번호 입력 필드 표시 -->
          <div class="info-group" v-if="isEditing">
            <label>현재 비밀번호</label>
            <input 
              type="password" 
              v-model="currentPassword"
              placeholder="현재 비밀번호를 입력하세요"
              class="form-input"
              required
            >
          </div>

          <!-- 버튼 영역 -->
          <div class="button-group">
            <template v-if="!isEditing">
              <button type="button" @click="startEdit" class="edit-btn">정보 수정</button>
              <button type="button" @click="showPasswordChange" class="edit-btn">비밀번호 변경</button>
            </template>
            <template v-else>
              <button type="submit" class="save-btn">저장</button>
              <button type="button" @click="cancelEdit" class="cancel-btn">취소</button>
            </template>
          </div>
        </form>

        <!-- 비밀번호 변경 섹션 -->
        <div v-if="isPasswordChanging" class="password-change-section">
          <h3>비밀번호 변경</h3>
          <form @submit.prevent="handlePasswordChange" class="password-form">
            <div class="info-group">
              <label>현재 비밀번호</label>
              <input 
                type="password" 
                v-model="passwordChange.currentPassword"
                placeholder="현재 비밀번호"
                class="form-input"
                required
              >
            </div>
            <div class="info-group">
              <label>새 비밀번호</label>
              <input 
                type="password" 
                v-model="passwordChange.newPassword"
                placeholder="새 비밀번호"
                class="form-input"
                required
              >
            </div>
            <div class="info-group">
              <label>새 비밀번호 확인</label>
              <input 
                type="password" 
                v-model="passwordChange.confirmPassword"
                placeholder="새 비밀번호 확인"
                class="form-input"
                required
              >
              <span style="font-size: 10px; margin-top: 10px;">※ 공백없이 8~20자의 영문 소문자, 특수문자, 숫자로만 사용 할 수 있습니다.</span>
            </div>
            <div class="button-group">
              <button type="submit" class="save-btn">저장</button>
              <button type="button" @click="cancelPasswordChange" class="cancel-btn">취소</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SeedJung_Header from './SeedJung_Header.vue'

export default {
  name: 'SeedJung_Mypage',
  components: {
    SeedJung_Header
  },
  data() {
    return {
      isEditing: false,
      isPasswordChanging: false,
      currentPassword: '',
      userInfo: {
        nickname: '',
        email: ''
      },
      username:'',
      originalInfo: null,
      passwordChange: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  created() {
    this.username = this.currentUser.username
    this.userInfo.nickname = this.currentUser.nickname
    this.userInfo.email = this.currentUser.email
    this.originalInfo = { ...this.userInfo }
  },
  methods: {
    validatePassword(password) {
      // 8~20자 길이 체크
      if (password.length < 8 || password.length > 20) {
        alert('비밀번호는 8~20자 사이여야 합니다.');
        return false;
      }

      // 공백 체크
      if (password.includes(' ')) {
        alert('비밀번호에 공백을 포함할 수 없습니다.');
        return false;
      }

      // 영문 소문자, 특수문자, 숫자 포함 체크
      const passwordRegex = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-z0-9!@#$%^&*]{8,20}$/;
      if (!passwordRegex.test(password)) {
        alert('비밀번호는 영문 소문자, 특수문자, 숫자를 모두 포함해야 합니다.');
        return false;
      }

      return true;
    },    
    validateNickname() {
      if (this.userInfo.nickname < 2) {
        alert('닉네임은 2글자 이상이어야 합니다.');
        return false;
      }

      // 한글 자음 또는 모음만으로 이루어진 문자열 체크
      const koreanJamoRegex = /^[ㄱ-ㅎㅏ-ㅣ]+$/;
      if (koreanJamoRegex.test(this.userInfo.nickname)) {
        alert('닉네임에 자음 또는 모음만 사용할 수 없습니다.');
        return false;
      }

      // 유효한 문자만 포함되어 있는지 체크 (한글, 영문, 숫자)
      const validCharRegex = /^[가-힣a-zA-Z0-9]+$/;
      if (!validCharRegex.test(this.userInfo.nickname)) {
        alert('닉네임은 한글, 영문, 숫자만 사용 가능합니다.');
        return false;
      }

      return true;
    },    
    startEdit() {
      this.isEditing = true
      this.isPasswordChanging = false
    },
    cancelEdit() {
      this.userInfo = { ...this.originalInfo }
      this.isEditing = false
      this.currentPassword = ''
    },
    showPasswordChange() {
      this.isPasswordChanging = true
      this.isEditing = false
    },
    cancelPasswordChange() {
      this.isPasswordChanging = false
      this.passwordChange = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    async handleUpdate() {
        try {
          if (!this.validateNickname()) { // 유효성 검사 실패시 함수 종료
            return;
          }
        const response = await this.$axios.post('/api/user/update', {
          username: this.currentUser.username,
          nickname: this.userInfo.nickname,
          email: this.userInfo.email,
          password: this.currentPassword
        })

        if (response.data.success) {
          this.$store.commit('updateUser', {
            ...this.currentUser,
            nickname: this.userInfo.nickname,
            email: this.userInfo.email
          })
          
          this.originalInfo = { ...this.userInfo }
          this.isEditing = false
          this.currentPassword = ''
          alert('정보가 성공적으로 수정되었습니다.')
        }
      } catch (error) {
        if (error.response) {
          // 서버에서 보낸 에러 메시지가 있으면 그것을 표시
          alert(error.response.data.message || '정보 수정 중 오류가 발생했습니다.')
        } else {
          alert('서버와의 통신 중 오류가 발생했습니다.')
        }
        console.error('Update error:', error)
      }
    },
    async handlePasswordChange() {
      if (this.passwordChange.newPassword !== this.passwordChange.confirmPassword) {
        alert('새 비밀번호가 일치하지 않습니다.');
        return;
      }

      if (!this.validatePassword(this.passwordChange.newPassword)) {
        return;
      }

      try {
        const response = await this.$axios.post('/api/user/change-password', {
          username: this.currentUser.username,
          currentPassword: this.passwordChange.currentPassword,
          newPassword: this.passwordChange.newPassword
        });

        if (response.data.success) {
          alert('비밀번호가 성공적으로 변경되었습니다.');
          this.cancelPasswordChange();
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          alert('현재 비밀번호가 일치하지 않습니다.');
        } else {
          alert('비밀번호 변경 중 오류가 발생했습니다.');
        }
        console.error('Password change error:', error);
      }
    }
  }
}
</script>

<style scoped>
.sc-fzsDOv {
  margin-top: 150px;
}

.mypage-container {
  max-width: 600px;
  margin: 40px auto;
  padding: 20px;
}

h2 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
  font-size: 24px;
}

.profile-section {
  background-color: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.info-group {
  margin-bottom: 20px;
}

.info-group label {
  display: block;
  margin-bottom: 8px;
  color: #666;
  font-size: 14px;
}

.info-value {
  padding: 10px;
  background-color: #f8f8f8;
  border-radius: 6px;
  color: #333;
  font-size: 16px;
}

.form-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-input:disabled {
  background-color: #f8f8f8;
  cursor: not-allowed;
}

.form-input:focus {
  outline: none;
  border-color: #032f3e;
}

.button-group {
  margin-top: 30px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.edit-btn, .save-btn, .cancel-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.edit-btn, .save-btn {
  background-color: #032f3e;
  color: white;
}

.cancel-btn {
  background-color: #666;
  color: white;
}

.edit-btn:hover, .save-btn:hover {
  background-color: #072c53;
}

.cancel-btn:hover {
  background-color: #555;
}

.password-change-section {
  margin-top: 30px;
  border-top: 1px solid #ddd;
  padding-top: 30px;
}

.password-change-section h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 18px;
  text-align: center;
}

.password-form {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .mypage-container {
    padding: 15px;
    margin: 20px auto;
  }

  .profile-section {
    padding: 20px;
  }

  .form-input {
    font-size: 14px;
  }

  .button-group {
    flex-direction: column;
  }

  .edit-btn, .save-btn, .cancel-btn {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>